module.exports = __webpack_public_path__ + "img/feedback-up-active.74d9d405.png";